<p-dialog class="minWidth80" [(visible)]="visibility" [responsive]="true" [modal]="true" (onHide)="closeDialog()">
    <p-header>
        <h2>{{ patentInventor === null ? ('fs.res.patent.inventors.assignPerson'|hisUi) : ('common.editOf'|hisUi:('fs.res.patent.Patent.inventors.percentages'|hisUi)) }}</h2>
    </p-header>

    <ng-container *ngIf="patentInventor === null; else editPercentage">
        <p-steps #steps class="wizardSteps centeringContainer" [model]="menuItems" [activeIndex]="activeIndex"></p-steps>
        
        <ng-container *ngIf="activeIndex === 0">
            <res-patent-search-internal-person-inventor
                [patentInventor]="currentPatentInventor"
                (submitPatentInventor)="submitPatentInventor()">
            </res-patent-search-internal-person-inventor>
        </ng-container>
        <ng-container *ngIf="activeIndex === 1">
            <res-patent-edit-inventor-percentage
              [patentInventor]="currentPatentInventor">
            </res-patent-edit-inventor-percentage>
        </ng-container>
        
        <p-footer>
            <button *ngIf="activeIndex === 1" (click)="activeIndex = 0">
                <span>{{'common.back'|hisUi}}</span>
            </button>
            <button *ngIf="activeIndex === 1" (click)="savePatentInventor()">
                <span>{{'common.apply'|hisUi}}</span>
            </button>
         </p-footer>
        
    </ng-container>
    
    <ng-template #editPercentage>
        <res-patent-edit-inventor-percentage
            [patentInventor]="currentPatentInventor">
        </res-patent-edit-inventor-percentage>
        
        <p-footer>
            <button (click)="savePatentInventor()">
                <span>{{'common.apply'|hisUi}}</span>
            </button>
            <button (click)="closeDialog()">
                <span>{{'common.cancel'|hisUi}}</span>
            </button>
        </p-footer>
        
    </ng-template>
    
</p-dialog>
    